import { Link, useParams } from 'react-router-dom';
import { ApiUnavailablePanel } from '../../components/ui/ApiUnavailablePanel';
import { buttonBase, buttonVariants } from '../../components/ui/Button';

export function ProviderExceptionDetailPage() {
  const { exceptionId } = useParams();

  return (
    <div className="space-y-5">
      <ApiUnavailablePanel title={`Exception ${exceptionId}`}>
        Exception detail is not available yet. Open alerts from the exceptions
        list into the related package or integrations screen.
      </ApiUnavailablePanel>
      <Link
        to="/provider/exceptions"
        className={`${buttonBase} ${buttonVariants.ghost}`}
      >
        ← Back to exceptions
      </Link>
    </div>
  );
}
